'use client';

import { ErrorTemplate } from '@components/common/error-template';

interface ProductDetailsErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ProductDetailsError({
  error,
  reset,
}: Readonly<ProductDetailsErrorProps>) {
  return (
    <ErrorTemplate
      error={error}
      message='Unable to load product details. Please try again.'
      reset={reset}
    />
  );
}
